var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',_vm._b({attrs:{"color":_vm.backgroundColor}},'v-avatar',_vm.$props,false),[_vm._t("default",function(){return [_c('span',{staticClass:"font-weight-medium",style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.shortenName(_vm.currentUsername)))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }